<template>
  <div>
    <Series />
  </div>
</template>

<script>
import Series from "@/components/Series/index.vue";
export default {
  components: {
    Series,
  },
};
</script>

<style></style>
